<template>
  <div class="m-0 dbozone-font bg-mahjongTiger" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex py-5  justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.name') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center pb-4">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.paytable') }}</h5>
      </div>

      <div class="d-flex py-2 px-4  justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
          $t('mahjongTiger.paytable-des') }}
        </h5>
      </div>

      <div class="symbols-container">
        <div class="d-flex pt-4 justify-content-center align-items-center">
          <img :src="require(`../../assets/ruleGames/mahjongTiger/scatter.png`)" alt="wild-coming"
            class="special-symbol-image" />
        </div>
        <div class="d-flex pt-5 pb-2 justify-content-center align-items-center">
          <h5 class="text-special-symbol" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.scatter')
          }}</h5>
        </div>

        <div class="d-flex pt-4 justify-content-center align-items-center">
          <img :src="require(`../../assets/ruleGames/mahjongTiger/wild.png`)" alt="wild-coming"
            class="special-symbol-image" />
        </div>
        <div class="d-flex pt-5 pb-2 justify-content-center align-items-center">
          <h5 class="text-special-symbol" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.wild')
          }}
          </h5>
        </div>

        <div class="grid-container">
          <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">
            <img :src="symbol.image" class="symbol-image" alt="symbol" />
            <div class="payouts">
              <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
                class="payout-row">
                <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">
                  {{ key }}&nbsp;&nbsp;|
                </span>
                <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} `">{{ $t('oneboxing.adjustment') }}</h5>
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`oneboxing.adjustment-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>


      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">


      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.scatter-symbol') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <div class="d-flex pt-4 pl-3 justify-content-center align-items-center">
          <img :src="require(`../../assets/ruleGames/mahjongTiger/scatter.png`)" alt="wild-coming"
            class="special-symbol-image" />
        </div>
        <div class="d-flex p-4 justify-content-center align-items-center">
          <u>
            <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
              $t('mahjongTiger.scatter-symbol-desc1') }}
            </li>
          </u>
        </div>
      </div>


      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-2 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.gold') }}</h5>
      </div>
      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/change_wild.png`)" alt="wild-coming"
          class="special-symbol-image2" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`mahjongTiger.gold-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>


      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.wild') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <div class="d-flex pt-4 pl-3 justify-content-center align-items-center">
          <img :src="require(`../../assets/ruleGames/mahjongTiger/wild.png`)" alt="wild-coming"
            class="special-symbol-image" />
        </div>
        <div class="d-flex p-4 justify-content-center align-items-center">
          <u>
            <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
              $t('mahjongTiger.wild-des1') }}
            </li>
            <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
              $t('mahjongTiger.wild-des2') }}
            </li>
          </u>
        </div>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-5 pb-2 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.combo') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/combo.png`)" alt="wild-coming"
          class="special-symbol-image3" />
      </div>

      <div class="symbol-content pt-4 pr-3">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`mahjongTiger.combo-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>


      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">


      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.freespin') }}</h5>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/scatter.png`)" alt="wild-coming"
          class="special-symbol-image" />
        <img :src="require(`../../assets/ruleGames/mahjongTiger/scatter.png`)" alt="wild-coming"
          class="special-symbol-image" />
        <img :src="require(`../../assets/ruleGames/mahjongTiger/scatter.png`)" alt="wild-coming"
          class="special-symbol-image" />
      </div>

      <div class="symbol-content pt-4 pr-3">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`mahjongTiger.freespin-desc${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <table class="control-table">
        <tr v-for="(val, index) in 4" :key="index">
          <td> <img :src="require(`../../assets/ruleGames/mahjongTiger/freespins_selection${index + 1}.png`)"
              alt="wild-coming" class="special-symbol-image" /></td>
          <td>
            <li class="sub-text-list-gray" style="white-space: pre-wrap;">{{ $t(`mahjongTiger.freespin-select${index +
              1}`) }}</li>
          </td>
        </tr>
      </table>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">



      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/feature_buy_${getImgLang(lang)}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex p-4 pt-5 pl-5 justify-content-left align-items-left">
        <span>
          <li v-for="(value, index) in 6" :key="index" class="sub-text-gray" :class="`-${lang} -mahjongTiger`">
            {{ $t(`mahjongTiger.featurebuy-des${index + 1}`).replace('MIN',
              currencyFormatterWithSymbol(betMinMax[0]))
              .replace('MAX', currencyFormatterWithSymbol(featureBuyMaximum))
              .replace('MUL', featureBuyMultiplier) }}</li>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex p-4 pl-5 justify-content-left align-items-left">
        <span>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways-des5')
          }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways-des6')
          }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways-des7')
          }}
          </li>
        </span>
      </div>

      <!-- <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;"> -->

      <!-- <div class="d-flex pt-5  justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways') }}</h5>
      </div> -->

      <!-- <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/win_line.png`)" alt="wild-coming"
          class="win-line-images" />
      </div> -->

      <!-- <div class="d-flex p-4 pt-2 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways-des1')
            }}
          </li>
          <div class="sub-text-gray py-3 text-des text-center" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.ways-des2')
          }}
          </div>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.ways-des3')
            }}
          </li>

          <div class="payout-table">
            <img :src="require(`../../assets/ruleGames/tiki/symbols.png`)" alt="question-symbol"
              class="special-symbol-image" />
            <div class="payout-info pl-3">
              <ul>
                <li class="sub-text-gray">5 &nbsp;&nbsp;&nbsp; 60</li>
                <li class="sub-text-gray">4 &nbsp;&nbsp;&nbsp; 40</li>
                <li class="sub-text-gray">3 &nbsp;&nbsp;&nbsp; 30</li>
              </ul>
            </div>
          </div>


          <div class="sub-text-gray text-des text-center" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.ways-des4')
            }}
          </div>
          <div class="example-win text-center pb-3" :class="`-${lang} -mahjongTiger`">3 x 30 = 90</div>

        </u>
      </div> -->

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="volatility-wrapper">
        <img :src="require(`../../assets/ruleGames/volality/volatility_${imgLang}.png`)" class="volatility-image"
          alt="" />

        <div class="fire-container">
          <img v-for="(fire, index) in fires" :key="index" :src="getFireSrc(fire)" class="volatility-image-fire" />
        </div>
      </div>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.game-rule') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des py-2 px-4" :class="`-${lang} -mahjongTiger`">{{
          $t('mahjongTiger.game-rule-des') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/mahjongTiger/slotmachine.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 pt-5 justify-content-left align-items-left">
        <span>
          <div v-for="(value, index) in 11" :key="index">
            <li v-if="index != 5" class="sub-text-gray" :class="`-${lang} -mahjongTiger`">
              {{ $t(`mahjongTiger.game-rule${index + 1}`).replace('MIN',
                currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1])).replace('CUR', formattedCurrency) }}
            </li>
            <li v-else-if="isShowCurrencySymbol === true" class="sub-text-gray" :class="`-${lang} -mahjongTiger`">
              {{ $t(`mahjongTiger.game-rule${index + 1}`).replace('MIN',
                currencyFormatterWithSymbol(betMinMax[0]))
                .replace('MAX', currencyFormatterWithSymbol(betMinMax[1])).replace('CUR', formattedCurrency) }}
            </li>
          </div>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.round-des')
            }}
          </h5>
          <div class="pl-3">
            <li v-for="(li, index) in 5" :key="index" class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">
              {{
                $t(`mahjongTiger.round-des${index + 1}`)
              }}
            </li>
            <div class="pl-3">
              <li v-for="(li, index) in 4" :key="index" class="sub-text-gray text-des"
                :class="`-${lang} -mahjongTiger`">
                {{
                  $t(`mahjongTiger.round-des5-${index + 1}`)
                }}
              </li>
            </div>
            <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
              $t(`mahjongTiger.round-des6`)
              }}
            </li>
          </div>
        </span>
      </div>

      <hr style="border: none; border-top: 1px solid #000; margin: 20px 0;">

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_spin.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_auto_spin.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_auto_spin_on.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_betsize.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_info.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_additional.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_setting.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_history.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/btn_home.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/icon_wallet.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/mahjongTiger/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.winnings-button-des${index
                + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -mahjongTiger`">{{ $t('mahjongTiger.additional') }}</h5>
      </div>

      <div class="d-flex p-4  justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.additional-des1')
            }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -mahjongTiger`">{{
            $t('mahjongTiger.additional-des2')
            }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-mahjongTiger',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: [],
      fires: [true, true, true, true, false],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      const cur = this.isShowCurrencySymbol === false ? '' : this.currency;
      return this.$options.filters.currencyFormatterWithSymbol(val, cur);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 8; i++) {
        const id = (8 - i) - 1;
        symbolsData.push({
          id: id,
          image: require(`../../assets/ruleGames/mahjongTiger/symbol_${id}.png`),
          payouts: {
            5: this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet),
            4: this.decimalFormat(this.currentBet * this.data.config.payTable[id][3] / this.baseBet),
            3: this.decimalFormat(this.currentBet * this.data.config.payTable[id][2] / this.baseBet),
          }
        });
      }
      this.symbols = symbolsData;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet).length;
      let magin = 'calc(35%)'

      if (maxLength < 5) {
        magin = 'calc(35%)'
      } else if (maxLength <= 5) {
        magin = 'calc(32%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(30%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(28%)'
      } else if (maxLength >= 9 && maxLength < 10) {
        magin = 'calc(25%)'
      } else {
        magin = 'calc(20%)'
      }

      return {
        marginLeft: magin,
      };
    },
    getImgLang(lang) {
      if (lang === 'cn') return 'zh';
      else if (lang === 'en' || lang === 'th' || lang === 'zh' || lang === 'id' || lang === 'ph') return lang;
      else return 'en';
    },
    getFireSrc(fire) {
      return require(
        fire
          ? `../../assets/ruleGames/volality/fire_appear.png`
          : `../../assets/ruleGames/volality/fire_disappear.png`
      );
    }
  }
}
</script>

<style scoped>
.symbols-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0px;
  padding: 0px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: 70%;
  height: auto;
}

.payouts {
  margin-top: 10px;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: clamp(120px, 90px, 150px);
  height: auto;
}

.special-symbol-image2 {
  width: 40%;
  /* margin-right: 20px; */
}

.special-symbol-image3 {
  width: 80%;
  /* margin-right: 20px; */
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 40%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 90%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  width: clamp(250px, 10vw, 150px);
  height: auto;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 80%;
  height: auto;
}
</style>

<style>
.bg-mahjongTiger {
  background: #282828;
}

.game-title {
  font-size: 3vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.text-special-symbol {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
  /* margin: 0 8px; */
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: clamp(78px, 10vw, 150px);
  height: auto;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}

.volatility-wrapper {
  position: relative;

  width: 100%;
  max-width: 600px;

  margin: 0 auto;

  display: flex;
  justify-content: center;
}

.volatility-image {
  width: 70%;
  height: auto;
  display: block;
}

.fire-container {
  position: absolute;

  top: 22%;
  right: 22%;

  display: flex;
  align-items: center;

  gap: clamp(2px, 1vw, 6px);

  pointer-events: none;
}

.volatility-image-fire {
  width: clamp(18px, 4vw, 28px);
  height: auto;

  object-fit: contain;
}
</style>